import { Component, OnInit } from '@angular/core';
import { ConfirmationService, MessageService, PrimeNGConfig } from 'primeng/api';
import { ClienteModel } from 'src/app/cliente/cliente-model';
import { FuncionarioModel } from 'src/app/helpers/funcionario-model';
import { CodigoAtendimentoModel } from 'src/app/models/codigo-atendimento.model';
import { Funcoes, Periodos } from 'src/app/services/funcoes';
import { Services } from 'src/app/services/servicos';

declare var google: any

@Component({
  selector: 'app-localizacao-tecnico-cliente',
  templateUrl: './localizacao-tecnico-cliente.component.html',
  styleUrls: ['./localizacao-tecnico-cliente.component.css']
})
export class LocalizacaoTecnicoClienteComponent implements OnInit {
  funcoes: Funcoes = new Funcoes();
  lista: ClienteModel[];
  listaNoUpdate: ClienteModel[];
  listaTecnico: FuncionarioModel[];
  selecionados: ClienteModel[];
  loading: boolean = false;
  options: any;
  overlays: any[];
  dialogVisible: boolean;
  markerTitle: string;
  selectedPosition: any;
  infoWindow: any;
  draggable: boolean;
  total_elevadores: number = 0
  total_clientes: number = 0
  periodos: Periodos[];
  selecionarPeriodo: string;

  filtros: ClienteModel = new ClienteModel();

  visita: string
  visitas: CodigoAtendimentoModel[];
  selecionarVisita: CodigoAtendimentoModel;
  tecnico: FuncionarioModel[];
  selecionarFuncionario: FuncionarioModel;

  data_inicial: Date = new Date()
  data_final: Date = new Date()

  constructor(private service: Services,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private config: PrimeNGConfig) {

    this.periodos = this.funcoes.Periodos;
    if (this.periodos.length > 0) {
      this.selecionaMesAtual();
    }

    //this.origens = this.funcoes.Origens;
  }

  selecionaMesAtual() {
    var today = new Date();
    var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
    this.selecionarPeriodo = this.periodos.find(c => c.cod == mm).nome;
    console.log(this.selecionarPeriodo);
    this.selecionaPeriodo(this.selecionarPeriodo);
  }

  ngOnInit(): void {
    //PESQUISANDO AO ABRIR
    //this.Listar();

    //this.startTimer();
    this.options = {
      center: { lat: -22.9053, lng: -47.0659 },
      zoom: 15,
    };

    this.config.setTranslation({
      accept: 'Aceitar',
      reject: 'Cancelar',
      dayNames: ["Domingo", "Segunda", "Terça", "Quarta", "Quinta", "Sexta", "Sábado"],
      dayNamesShort: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sab"],
      dayNamesMin: ["Do", "Se", "Te", "Qu", "Qu", "Se", "Sa"],
      monthNames: ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"],
      monthNamesShort: ["Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dez"],
      today: 'Hoje',
      clear: 'Limpar'
      //translations
    });

    //BUSCANDO FUNCIONARIO
    try {
      this.service.listarFuncionario()
        .subscribe(data => {
          if (data.Success) {
            this.tecnico = data.Response;
          }
        },
          err => console.error(err)
        );
    }
    catch (e) {
      alert(e);
    }
    //BUSCANDO VISITA
    try {
      this.service.listarVisita()
        .subscribe(data => {
          if (data.Success) {
            this.visitas = data.Response;
          }
        },
          err => console.error(err)
        );
    }
    catch (e) {
      alert(e);
    }
    //BUSCANDO VISITA 

    this.selecionaMesAtual();

  }

  // pesquisar() {
  //   this.loading = true;

  //   this.filtros.filtro_data_inicial = this.data_inicial;
  //   this.filtros.filtro_data_final = this.data_final;
  //   this.filtros.visita = this.selecionarVisita == null ? "" : this.selecionarVisita.descricao;

  //   try {
  //     this.service.listarTecnicoClienteFiltros(this.filtros)
  //       .subscribe(data => {
  //         if (data.Success) {
  //           this.lista = data.Response;
  //           this.loading = false;
  //           this.total_clientes = Number(data.Message) > 0 ? Number(data.Message) : 0;
  //           this.Totais();
  //           this.listaNoUpdate = this.lista;
  //           //console.log(this.lista)
  //           //this.initOverlays(this.lista);
  //           //this.initOverlaysTecnico(this.listaTecnico);
  //           //this.ListarTecnico();
  //           this.updateLista();
  //           this.infoWindow = new google.maps.InfoWindow("active");

  //         }
  //       },
  //         err => console.error(err)
  //       );
  //   }
  //   catch (e) {
  //     alert(e);
  //   }
  // }
  pesquisar() {
    this.Listar();
  }

  Listar() {
    this.loading = true;
    try {

      this.filtros = {}

      this.filtros.filtro_data_inicial = this.data_inicial;
      this.filtros.filtro_data_final = this.data_final;
      this.filtros.visita = this.selecionarVisita == null ? "" : this.selecionarVisita.descricao;

      this.service.BuscarTecnicoClienteFiltros(this.filtros)
        .subscribe(data => {
          if (data.Success) {
            this.lista = data.Response;
            this.loading = false;
            this.total_clientes = Number(data.Message) > 0 ? Number(data.Message) : 0;
            this.Totais();
            this.listaNoUpdate = this.lista;
            //this.updateLista();
            this.infoWindow = new google.maps.InfoWindow("active");
          } else {
            this.messageService.add({ severity: 'error', summary: 'Informação', detail: data.Message });
            this.loading = false;
          }
        },
          err => {
            this.messageService.add({ severity: 'error', summary: 'Informação', detail: "Não foi possível consultar! erro:" + err });
            this.loading = false;
          }
        );

    } catch (error) {
      this.messageService.add({ severity: 'error', summary: 'Informação', detail: "Não foi possível consultar! erro:" + error });
    }
  }

  handleMapClick(event) {
    this.dialogVisible = true;
    this.selectedPosition = event.latLng;
  }

  handleOverlayClick(event) {
    let isMarker = event.overlay.getTitle != undefined;
    if (isMarker) {
      let title = event.overlay.getTitle();
      this.infoWindow.setContent('' + title + '');
      this.infoWindow.open(event.map, event.overlay);
      event.map.setCenter(event.overlay.getPosition());
      this.messageService.add({ severity: 'info', summary: 'Funcionário', detail: title });
    }
    else {
      this.messageService.add({ severity: 'info', summary: 'Funcionário', detail: '' });
    }
  }

  verificarPinMapa(parcela: ClienteModel) {
    if (parcela.endereco_imagem == "assets/building_red32.png") {
      return 'red';
    }
    else if (parcela.endereco_imagem == "assets/building_yellow32.png") {
      return '#ded302';
    }
    else if (parcela.endereco_imagem == "assets/building_gray32.png") {
      return 'gray';
    }
    return 'gray';
  }

  addMarker() {
    this.overlays.push(new google.maps.Marker({ position: { lat: this.selectedPosition.lat(), lng: this.selectedPosition.lng() }, title: this.markerTitle, draggable: this.draggable }));
    this.markerTitle = null;
    this.dialogVisible = false;
  }

  Totais() {
    if (this.lista != null) {
      if (this.lista.length > 0) {
        this.total_elevadores = this.lista.filter(item => item.qtd)
          .reduce((sum, current) => sum + Number(current.qtd), 0)
        this.total_elevadores = this.lista.filter(item => item.qtd)
          .reduce((sum, current) => sum + Number(current.qtd), 0)
      } else {
        this.total_elevadores = 0;
      }
    } else {
      this.total_elevadores = 0;
    }
  }

  initOverlaysTecnico(listaTecnico: FuncionarioModel[]) {
    this.clear();
    if (this.overlays.length > 0) {

      listaTecnico.forEach((element) => {
        let lat = Number(element.latitude.replace(",", "."));
        let lon = Number(element.longitude.replace(",", "."));

        const icon = {
          url: element.endereco_imagem, // url
          scaledSize: new google.maps.Size(50, 50), // scaled size
          origin: new google.maps.Point(0, 0), // origin
          anchor: new google.maps.Point(0, 0), // anchor
        };

        this.overlays.push(
          new google.maps.Marker({
            position: { lat: lat, lng: lon },
            label: {
              text: element.apelido,
              fontSize: '0px',
            },
            title:
              "<b>Nome: " +
              element.nome +
              "<br>Endereço: " +
              element.endereco_tecnico +
              " - " +
              element.bairro_tecnico +
              "<br>Data: " +
              element.data_localizacao +
              "</b>",
            options: {
              animation: google.maps.Animation.DROP,
              icon: icon,
            }

          }),
        );
      });
    }
  }

  timeLeft: number = 180;
  interval;

  startTimer() {
    this.interval = setInterval(() => {
      if (this.timeLeft > 0) {
        this.timeLeft--;
      } else {
        this.timeLeft = 180;
        //console.log('Atualizou');
        this.Listar();
      }
      //console.log(this.timeLeft);
    }, 1000)
  }

  pauseTimer() {
    clearInterval(this.interval);
  }

  zoomIn(map) {
    map.setZoom(map.getZoom() + 1);
  }

  zoomOut(map) {
    map.setZoom(map.getZoom() - 1);
  }

  clear() {
    this.overlays = [];
  }

  ListarTecnico() {
    this.loading = true;
    try {
      this.service.Buscar().subscribe(
        (data) => {
          if (data.Success) {
            this.listaTecnico = data.Response;
            this.loading = false;

            this.initOverlaysTecnico(this.listaTecnico);
            //this.infoWindow = new google.maps.InfoWindow("active");
          }
        },
        (err) => console.error(err)
      );
    } catch (error) {
      this.messageService.add({
        severity: "error",
        summary: "Informação",
        detail: "Não foi possível consultar! erro:" + error,
      });
    }
  }
  setarPosicao(map, dados: ClienteModel) {
    console.log(dados)
    console.log(this.overlays)
    let position;

    for (let index = 0; index < this.overlays.length; index++) {
      const element = this.overlays[index];
      // console.log(element.title)
      // console.log(element.position)

      if (element.label != null) {
        if (dados.cod_cliente == element.label.text) {
          //console.log(element)
          position = element.position;
          this.infoWindow.setContent("" + element.title + "");
          this.infoWindow.open(map, element);
          map.setCenter(position);
          return;
        }
      }
    }

    //map.setCenter(event.overlay.getPosition());
  }

  selecionaVisita(event) {
    if (event.value != null) {
      this.updateLista();
      this.visita = event.value;
      //console.log(event)
    } else {
      this.visita = "";
      this.updateLista();
    }
  }
  updateLista() {

    let array = [... this.listaNoUpdate]
    console.log(this.listaNoUpdate);
    // if (this.check_sem_chamado == true && this.check_com_tecnico == true && this.check_sem_tecnico == true) {
    //   array = array.filter(x => x.endereco_imagem == "assets/building_red32.png" || x.endereco_imagem == "assets/building_yellow32.png" || x.endereco_imagem == "assets/building_gray32.png");
    // }
    // else if (this.check_sem_chamado == true && this.check_com_tecnico == true && this.check_sem_tecnico == false) {
    //   array = array.filter(x => x.endereco_imagem == "assets/building_yellow32.png" || x.endereco_imagem == "assets/building_gray32.png");
    // }
    // else if (this.check_sem_chamado == true && this.check_com_tecnico == false && this.check_sem_tecnico == false) {
    //   array = array.filter(x => x.endereco_imagem == "assets/building_gray32.png");
    // }
    // else if (this.check_sem_chamado == false && this.check_com_tecnico == true && this.check_sem_tecnico == true) {
    //   array = array.filter(x => x.endereco_imagem == "assets/building_red32.png" || x.endereco_imagem == "assets/building_yellow32.png");
    // }
    // else if (this.check_sem_chamado == false && this.check_com_tecnico == false && this.check_sem_tecnico == true) {
    //   array = array.filter(x => x.endereco_imagem == "assets/building_red32.png");
    // }
    // else if (this.check_sem_chamado == false && this.check_com_tecnico == true && this.check_sem_tecnico == false) {
    //   array = array.filter(x => x.endereco_imagem == "assets/building_yellow32.png");
    // }
    // else if (this.check_sem_chamado == true && this.check_com_tecnico == false && this.check_sem_tecnico == true) {
    //   array = array.filter(x => x.endereco_imagem == "assets/building_red32.png" || x.endereco_imagem == "assets/building_gray32.png");
    // }
    // else {
    //   //array = null;
    // }

    if (array != null) {
      //console.log(array);
      if (this.visita) {
        console.log('visita vazia');
        array = array.filter(x => x.visita == this.visita);
      }
      // console.log(array);

    }
    this.initOverlays(array);
    this.initOverlaysTecnico(array);
  }

  initOverlays(lista: ClienteModel[]) {
    //if (!this.overlays || !this.overlays.length) {
      this.clear();

    if (lista != null) {
      lista.forEach((element) => {

        if (element.latitude != null) { }
        let lat = Number(element.latitude.replace(",", "."));
        let lon = Number(element.longitude.replace(",", "."));

        // console.log(lat);
        // console.log(lon);

        const icon = {
          url: element.endereco_imagem, // url
          scaledSize: new google.maps.Size(45, 45), // scaled size
          origin: new google.maps.Point(0, 0), // origin
          anchor: new google.maps.Point(0, 0), // anchor
        };

        this.overlays.push(
          new google.maps.Marker({
            position: { lat: lat, lng: lon },
            label: {
              text: String(element.cod_cliente),
              fontSize: '0px',
            },
            title:
              "Nome: " +
              element.nome +
              "\nEndereço: " +
              element.endereco_cobranca + ", " + element.numero_cobranca +
              " - " +
              element.bairro_cobranca,
            options: {
              animation: google.maps.Animation.DROP,
              icon: icon,
            }
          })
        );
      });
    }
    else {
      lista = null;
    }

    // this.lista = [...lista]
    // this.Totais();
    // this.ListarTecnico();
    //}
  }

  onChangePeriodo(event) {
    if (event.value != null) {
      this.selecionaPeriodo(event.value);
      console.log(event);
    }
  }

  selecionaPeriodo(mes: string) {
    console.log('LOKOOOOO' + mes);
    if (mes == "Todos") {
      this.data_inicial = new Date(1950, 1, 1);
      this.data_final = new Date();
    }
    else if (mes == "3 Meses") {
      var today = new Date();
      this.data_inicial = new Date(today.getFullYear(), today.getMonth() + 1, (today.getDay() - 111));
      this.data_final = new Date();
      console.log((today.getDay() - 90));
      console.log(today);
      console.log(this.data_inicial);
    }
    else if (mes == "6 Meses") {

      var today = new Date();
      this.data_inicial = new Date(today.getFullYear(), today.getMonth() + 1, (today.getDay() - 201));
      this.data_final = new Date();
      console.log((today.getDay() - 180));
      console.log(today);
      console.log(this.data_inicial);
    }
    else if (mes == "9 Meses") {
      var today = new Date();
      this.data_inicial = new Date(today.getFullYear(), today.getMonth() + 1, (today.getDay() - 291));
      this.data_final = new Date();
      console.log((today.getDay() - 270));
      console.log(today);
      console.log(this.data_inicial);
    }
    else if (mes == "1 Ano") {

      var today = new Date();
      this.data_inicial = new Date(today.getFullYear(), today.getMonth() + 1, (today.getDay() - 386));
      this.data_final = new Date();
      console.log((today.getDay() - 365));
      console.log(today);
      console.log(this.data_inicial);
    }
    else if (mes == "Janeiro") {

      var today = new Date();
      this.data_inicial = new Date(today.getFullYear(), 0, 1);
      var ultimoDia = new Date(this.data_inicial.getFullYear(), this.data_inicial.getMonth() + 1, 0);
      this.data_final = ultimoDia;
      console.log(ultimoDia.getDate());
    }
    else if (mes == "Fevereiro") {

      var today = new Date();
      this.data_inicial = new Date(today.getFullYear(), 1, 1);
      var ultimoDia = new Date(this.data_inicial.getFullYear(), this.data_inicial.getMonth() + 1, 0);
      this.data_final = ultimoDia;
      console.log(ultimoDia.getDate());
    }
    else if (mes == "Março") {
      var today = new Date();
      this.data_inicial = new Date(today.getFullYear(), 2, 1);
      var ultimoDia = new Date(this.data_inicial.getFullYear(), this.data_inicial.getMonth() + 1, 0);
      this.data_final = ultimoDia;
      console.log(ultimoDia.getDate());
    }
    else if (mes == "Abril") {
      var today = new Date();
      this.data_inicial = new Date(today.getFullYear(), 3, 1);
      var ultimoDia = new Date(this.data_inicial.getFullYear(), this.data_inicial.getMonth() + 1, 0);
      this.data_final = ultimoDia;
      console.log(ultimoDia.getDate());
    }
    else if (mes == "Maio") {
      var today = new Date();
      this.data_inicial = new Date(today.getFullYear(), 4, 1);
      var ultimoDia = new Date(this.data_inicial.getFullYear(), this.data_inicial.getMonth() + 1, 0);
      this.data_final = ultimoDia;
      console.log(ultimoDia.getDate());
    }
    else if (mes == "Junho") {
      var today = new Date();
      this.data_inicial = new Date(today.getFullYear(), 5, 1);
      var ultimoDia = new Date(this.data_inicial.getFullYear(), this.data_inicial.getMonth() + 1, 0);
      this.data_final = ultimoDia;
      console.log(ultimoDia.getDate());
    }
    else if (mes == "Julho") {
      var today = new Date();
      this.data_inicial = new Date(today.getFullYear(), 6, 1);
      var ultimoDia = new Date(this.data_inicial.getFullYear(), this.data_inicial.getMonth() + 1, 0);
      this.data_final = ultimoDia;
      console.log(ultimoDia.getDate());
    }
    else if (mes == "Agosto") {
      var today = new Date();
      this.data_inicial = new Date(today.getFullYear(), 7, 1);
      var ultimoDia = new Date(this.data_inicial.getFullYear(), this.data_inicial.getMonth() + 1, 0);
      this.data_final = ultimoDia;
      console.log(ultimoDia.getDate());
    }
    else if (mes == "Setembro") {
      var today = new Date();
      this.data_inicial = new Date(today.getFullYear(), 8, 1);
      var ultimoDia = new Date(this.data_inicial.getFullYear(), this.data_inicial.getMonth() + 1, 0);
      this.data_final = ultimoDia;
      console.log(ultimoDia.getDate());
    }
    else if (mes == "Outubro") {
      var today = new Date();
      this.data_inicial = new Date(today.getFullYear(), 9, 1);
      var ultimoDia = new Date(this.data_inicial.getFullYear(), this.data_inicial.getMonth() + 1, 0);
      this.data_final = ultimoDia;
      console.log(ultimoDia.getDate());
    }
    else if (mes == "Novembro") {
      var today = new Date();
      this.data_inicial = new Date(today.getFullYear(), 10, 1);
      var ultimoDia = new Date(this.data_inicial.getFullYear(), this.data_inicial.getMonth() + 1, 0);
      this.data_final = ultimoDia;
      console.log(ultimoDia.getDate());
    }
    else if (mes == "Dezembro") {
      var today = new Date();
      this.data_inicial = new Date(today.getFullYear(), 11, 1);
      var ultimoDia = new Date(this.data_inicial.getFullYear(), this.data_inicial.getMonth() + 1, 0);
      this.data_final = ultimoDia;
      console.log(ultimoDia.getDate());
    }
  }

}
